var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.object.title))]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.object.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }